import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { NamedColorsHEX } from '../util/styles';
import { useMediaQuery } from 'react-responsive';
import { ShoppingCartItemUI } from '../util/types';
import { Link } from 'react-router-dom';
import { ScreenSizesPx } from '../util/styles';
import { Currencies } from 'shared/build/enums';
import { Money } from 'shared/build/Money';
import { Button } from 'ui-components/build';

const ScItemsTable = styled.table`
  width: 100%;
  th,
  td {
    padding: 5px 5px;
    min-width: 40px;
  }

  @media screen and (min-width: ${ScreenSizesPx.medium}px) {
    td:first-child {
      min-width: 350px;
    }
  }

  tbody tr:nth-child(even) td {
    background-color: ${NamedColorsHEX.PantoneCoconutMilk}38;
  }

  td.number {
    text-align: end;
  }

  .trash img {
    height: 20px;
  }
`;

export const ItemsTable = ({
  items,
  currency,
  actions = [],
}: {
  items: ShoppingCartItemUI[];
  currency: Currencies;
  actions?: {
    text: string;
    onClick: (itemId: string) => void;
  }[];
}) => {
  const [total, setTotal] = useState<Money>();
  const isSmall = useMediaQuery({
    query: `(min-width: ${ScreenSizesPx.small}px)`,
  });

  useEffect(() => {
    const total: Money = items.reduce((acc, item) => {
      return acc.add(item.unitPrice.multiply(item.quantity));
    }, new Money(0, currency));

    setTotal(total);
  }, [items, currency]);

  return (
    <ScItemsTable>
      <thead>
        <tr>
          <th>Descrição</th>
          <th>QTD</th>
          {isSmall && <th>Valor Unitário</th>}
          <th>Valor Total</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {items.map((item, i) => (
          <tr key={i}>
            <td>
              <Link to={`/presentes/${item.productId}`}>
                {item.title || ' '}
              </Link>
            </td>
            <td className="number">{item.quantity}</td>
            {isSmall && <td className="number">{item.unitPrice.toString()}</td>}
            <td className="number">
              {item.unitPrice.multiply(item.quantity).toString()}
            </td>
            <td className="number">
              {actions.map((action, i) => (
                <Button key={i} onClick={() => action.onClick(item.productId)}>
                  {action.text}
                </Button>
              ))}
            </td>
          </tr>
        ))}
        {items.length === 0 && (
          <tr>
            <td colSpan={5}>
              <p>A lista de presentes ainda está vazia.</p>
            </td>
          </tr>
        )}
      </tbody>
      <tfoot>
        {total && (
          <tr>
            <td colSpan={isSmall ? 3 : 2}>&nbsp;</td>
            <td className="number babys-bold-text">{total.toString()}</td>
          </tr>
        )}
      </tfoot>
    </ScItemsTable>
  );
};
